import { render, staticRenderFns } from "./order-settle-push.vue?vue&type=template&id=22bcbec2&scoped=true&"
import script from "./order-settle-push.vue?vue&type=script&lang=js&"
export * from "./order-settle-push.vue?vue&type=script&lang=js&"
import style0 from "./order-settle-push.vue?vue&type=style&index=0&id=22bcbec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bcbec2",
  null
  
)

export default component.exports